import { useCreateEntryFlowMutation as e, useDeleteEntryFlowMutation as t, useEntryFlowQuery as n, useEntryFlowsQuery as r, useLanguagesQuery as i, useUpdateEntryFlowMutation as a } from "@frontends/data-access-spg-entry-flows";
import { DsAlert as o, DsBadge as s, DsButton as c, DsCard as l, DsHeading as u, DsSelect as d, DsSelectItem as f, dsToast as p } from "@frontends/ds";
import { Page as m, PageHeader as h, PropertyList as g } from "@frontends/ui-spg-layout";
import { useTranslation as _ } from "react-i18next";
import { useNavigate as v, useParams as y, useSearchParams as b } from "react-router";
import { getErrorText as x, useForm as S } from "@frontends/form";
import { useField as C, useSelector as w } from "@tanstack/react-form";
import { Fragment as T, jsx as E, jsxs as D } from "react/jsx-runtime";
import { useAllInstancesQuery as O } from "@frontends/data-access-spg-instances";
import { getApiErrorMessage as k } from "@frontends/util-api-errors";
import { useState as A } from "react";
import { UiKitAlertDialog as j } from "@frontends/ui-kit";
import { useDataTable as M } from "@frontends/data-table";
//#region src/lib/constants.ts
var N = "feature-spg-entry-flows", P = [
	"trade_recency",
	"trade_count",
	"trade_volume"
], F = [
	"languageSelect",
	"accountCheck",
	"emailVerify",
	"ibCheck",
	"balanceCheck",
	"activityGate",
	"grantAccess"
];
function I(e, t) {
	return t === "languageSelect" ? e.languages.length > 1 : e.steps[t] !== void 0;
}
//#endregion
//#region src/lib/stepPositions.ts
function L(e) {
	let t = {}, n = 1;
	for (let r of F) e(r) && (t[r] = n++);
	return t;
}
//#endregion
//#region src/lib/components/LanguagesField.tsx
function R({ form: e, label: t, name: n, options: r }) {
	let i = C({
		form: e,
		name: n
	}), a = i.state.value ?? [], o = i.state.meta.isTouched ? x(i.state.meta.errors) : void 0;
	return /* @__PURE__ */ E(d, {
		selectionMode: "multiple",
		label: t,
		items: r,
		value: a,
		isFullWidth: !0,
		isInvalid: o !== void 0,
		errorMessage: o,
		onChange: (e) => i.handleChange(e.map(String)),
		onBlur: i.handleBlur,
		children: (e) => /* @__PURE__ */ E(f, {
			id: e.value,
			children: e.label
		})
	});
}
//#endregion
//#region src/lib/components/StepSection.tsx
function z({ stepKey: e, isEnabled: t, position: n, toggle: r, children: i }) {
	let { t: a } = _(N), o = a(`steps.${e}.title`);
	return /* @__PURE__ */ E(l, {
		title: n === void 0 ? o : `${n}. ${o}`,
		description: a(`steps.${e}.description`),
		action: r ?? (!t && /* @__PURE__ */ E(s, {
			size: "sm",
			children: a("view.off")
		})),
		className: "w-full",
		children: t && i
	});
}
//#endregion
//#region src/lib/components/EntryFlowForm.tsx
var B = {
	default_language: "defaultLanguage",
	max_step_retries: "maxStepRetries",
	"steps.account_check.referral_link": "referralLink",
	"steps.email_verify.max_email_attempts": "maxEmailAttempts",
	"steps.email_verify.max_code_attempts": "maxCodeAttempts",
	"steps.email_verify.code_length": "codeLength",
	"steps.email_verify.code_ttl_minutes": "codeTtlMinutes",
	"steps.email_verify.resend_cooldown_seconds": "resendCooldownSeconds",
	"steps.ib_check.partner_nodes": "partnerNodeQm",
	"steps.ib_check.partner_nodes.qm": "partnerNodeQm",
	"steps.ib_check.partner_nodes.tq": "partnerNodeTq",
	"steps.balance_check.min_balance_usd": "minBalanceUsd",
	"steps.activity_gate.metric": "activityMetric",
	"steps.activity_gate.threshold": "activityThreshold",
	"steps.activity_gate.window_days": "activityWindowDays",
	"steps.activity_gate.cooldown_days": "activityCooldownDays",
	"steps.activity_gate.instruments": "activityInstruments",
	"steps.grant_access.invite_link_ttl_minutes": "inviteLinkTtlMinutes"
}, V = new Intl.DisplayNames(["en"], { type: "language" });
function H({ code: e, badge: t }) {
	return {
		value: e,
		label: `${t} ${V.of(e) ?? e} (${e})`
	};
}
function U(e) {
	return String(e ?? "").trim();
}
function W(e) {
	return typeof e == "number" && !Number.isNaN(e) ? e : 0;
}
function G(e) {
	let t = Object.fromEntries([["qm", U(e.partnerNodeQm)], ["tq", U(e.partnerNodeTq)]].filter(([, e]) => e !== "")), n = U(e.activityInstruments).split(",").map((e) => e.trim()).filter(Boolean);
	return {
		name: U(e.name),
		languages: e.languages,
		defaultLanguage: U(e.defaultLanguage),
		maxStepRetries: W(e.maxStepRetries),
		steps: {
			accountCheck: { referralLink: U(e.referralLink) },
			emailVerify: {
				maxEmailAttempts: W(e.maxEmailAttempts),
				maxCodeAttempts: W(e.maxCodeAttempts),
				codeLength: W(e.codeLength),
				codeTtlMinutes: W(e.codeTtlMinutes),
				resendCooldownSeconds: W(e.resendCooldownSeconds)
			},
			ibCheck: { partnerNodes: t },
			balanceCheck: e.balanceCheckEnabled ? { minBalanceUsd: W(e.minBalanceUsd) } : void 0,
			activityGate: e.activityGateEnabled ? {
				metric: e.activityMetric,
				threshold: W(e.activityThreshold),
				windowDays: W(e.activityWindowDays),
				cooldownDays: W(e.activityCooldownDays),
				instruments: n.length > 0 ? n : void 0
			} : void 0,
			grantAccess: { inviteLinkTtlMinutes: W(e.inviteLinkTtlMinutes) }
		}
	};
}
function K(e, t) {
	return w(e.store, (e) => e.values[t]);
}
function q({ initial: e, notice: t, submitLabel: n, onSubmit: r }) {
	let { t: a } = _(N), s = i(), c = (s.data ?? []).map(H), d = { min: 1 }, f = e?.steps.emailVerify, p = e?.steps.balanceCheck, m = e?.steps.activityGate, h = S({
		fields: {
			name: {
				type: "text",
				label: a("fields.name"),
				defaultValue: e?.name ?? "",
				validators: ["required"]
			},
			languages: {
				type: "checkboxGroup",
				label: a("fields.languages"),
				defaultValue: e?.languages ?? ["en"],
				options: c,
				validators: ["required"]
			},
			defaultLanguage: {
				type: "select",
				label: a("fields.defaultLanguage"),
				defaultValue: e?.defaultLanguage ?? "en",
				options: c,
				validators: ["required"]
			},
			maxStepRetries: {
				type: "number",
				label: a("fields.maxStepRetries"),
				description: a("create.hints.maxStepRetries"),
				defaultValue: e?.maxStepRetries ?? 3,
				validators: ["required", d]
			},
			referralLink: {
				type: "text",
				label: a("steps.accountCheck.fields.referralLink"),
				description: a("create.hints.referralLink"),
				defaultValue: e?.steps.accountCheck.referralLink ?? "",
				placeholder: "https://",
				validators: [{
					pattern: /^https?:\/\/\S+$/,
					message: a("create.invalid.referralLink")
				}]
			},
			maxEmailAttempts: {
				type: "number",
				label: a("steps.emailVerify.fields.maxEmailAttempts"),
				defaultValue: f?.maxEmailAttempts ?? 3,
				validators: ["required", d]
			},
			maxCodeAttempts: {
				type: "number",
				label: a("steps.emailVerify.fields.maxCodeAttempts"),
				defaultValue: f?.maxCodeAttempts ?? 3,
				validators: ["required", d]
			},
			codeLength: {
				type: "number",
				label: a("steps.emailVerify.fields.codeLength"),
				defaultValue: f?.codeLength ?? 6,
				validators: [
					"required",
					{ min: 4 },
					{ max: 8 }
				]
			},
			codeTtlMinutes: {
				type: "number",
				label: a("create.fields.codeTtlMinutes"),
				defaultValue: f?.codeTtlMinutes ?? 10,
				validators: ["required", d]
			},
			resendCooldownSeconds: {
				type: "number",
				label: a("create.fields.resendCooldownSeconds"),
				defaultValue: f?.resendCooldownSeconds ?? 60,
				validators: ["required", { min: 0 }]
			},
			partnerNodeQm: {
				type: "text",
				label: a("steps.ibCheck.fields.partnerNode", { brand: "QM" }),
				defaultValue: e?.steps.ibCheck.partnerNodes.qm ?? ""
			},
			partnerNodeTq: {
				type: "text",
				label: a("steps.ibCheck.fields.partnerNode", { brand: "TQ" }),
				defaultValue: e?.steps.ibCheck.partnerNodes.tq ?? ""
			},
			balanceCheckEnabled: {
				type: "switch",
				label: a("create.enable"),
				defaultValue: !!p
			},
			minBalanceUsd: {
				type: "number",
				label: a("create.fields.minBalanceUsd"),
				description: a("create.hints.minBalance"),
				defaultValue: p?.minBalanceUsd ?? 100
			},
			activityGateEnabled: {
				type: "switch",
				label: a("create.enable"),
				defaultValue: !!m
			},
			activityMetric: {
				type: "select",
				label: a("steps.activityGate.fields.metric"),
				defaultValue: m?.metric ?? "trade_recency",
				options: P.map((e) => ({
					value: e,
					label: a(`metrics.${e}`)
				}))
			},
			activityThreshold: {
				type: "number",
				label: a("steps.activityGate.fields.threshold"),
				defaultValue: m?.threshold ?? 1
			},
			activityWindowDays: {
				type: "number",
				label: a("create.fields.windowDays"),
				defaultValue: m?.windowDays ?? 30
			},
			activityInstruments: {
				type: "text",
				label: a("steps.activityGate.fields.instruments"),
				description: a("create.hints.instruments"),
				defaultValue: m?.instruments?.join(", ") ?? ""
			},
			activityCooldownDays: {
				type: "number",
				label: a("create.fields.cooldownDays"),
				description: a("create.hints.cooldownDays"),
				defaultValue: m?.cooldownDays ?? 0
			},
			inviteLinkTtlMinutes: {
				type: "number",
				label: a("create.fields.inviteLinkTtlMinutes"),
				description: a("create.hints.inviteLinkTtl"),
				defaultValue: e?.steps.grantAccess.inviteLinkTtlMinutes ?? 60,
				validators: ["required", d]
			}
		},
		submitLabel: n,
		fieldMap: B,
		onSubmit: (e) => r(G(e))
	}), g = K(h.api, "languages") ?? [], v = K(h.api, "balanceCheckEnabled") === !0, y = K(h.api, "activityGateEnabled") === !0, b = K(h.api, "activityMetric"), x = L((e) => (e !== "languageSelect" || g.length > 1) && (e !== "balanceCheck" || v) && (e !== "activityGate" || y));
	return /* @__PURE__ */ D(T, { children: [s.isError && /* @__PURE__ */ E(o, {
		variant: "danger",
		title: a("create.languagesFailed"),
		actionLabel: a("view.retry"),
		onAction: () => void s.refetch()
	}), /* @__PURE__ */ D(h.Form, {
		className: "flex max-w-3xl flex-col gap-6",
		children: [
			t,
			/* @__PURE__ */ E(l, {
				title: a("view.general"),
				children: /* @__PURE__ */ D("div", {
					className: "flex flex-col gap-4",
					children: [
						/* @__PURE__ */ E(h.Field, { name: "name" }),
						/* @__PURE__ */ E(R, {
							form: h.api,
							name: "languages",
							label: a("fields.languages"),
							options: c
						}),
						/* @__PURE__ */ E(h.Field, {
							name: "defaultLanguage",
							disabledKeys: c.map(({ value: e }) => e).filter((e) => !g.includes(e))
						}),
						/* @__PURE__ */ E(h.Field, { name: "maxStepRetries" })
					]
				})
			}),
			/* @__PURE__ */ D("section", {
				className: "flex flex-col gap-4",
				children: [
					/* @__PURE__ */ E(u, {
						level: 2,
						size: "2xs",
						children: a("view.steps")
					}),
					/* @__PURE__ */ E(z, {
						stepKey: "languageSelect",
						position: x.languageSelect,
						isEnabled: g.length > 1
					}),
					/* @__PURE__ */ E(z, {
						stepKey: "accountCheck",
						position: x.accountCheck,
						isEnabled: !0,
						children: /* @__PURE__ */ E(h.Field, { name: "referralLink" })
					}),
					/* @__PURE__ */ E(z, {
						stepKey: "emailVerify",
						position: x.emailVerify,
						isEnabled: !0,
						children: /* @__PURE__ */ D("div", {
							className: "grid gap-4 sm:grid-cols-2",
							children: [
								/* @__PURE__ */ E(h.Field, { name: "maxEmailAttempts" }),
								/* @__PURE__ */ E(h.Field, { name: "maxCodeAttempts" }),
								/* @__PURE__ */ E(h.Field, { name: "codeLength" }),
								/* @__PURE__ */ E(h.Field, { name: "codeTtlMinutes" }),
								/* @__PURE__ */ E(h.Field, { name: "resendCooldownSeconds" })
							]
						})
					}),
					/* @__PURE__ */ D(z, {
						stepKey: "ibCheck",
						position: x.ibCheck,
						isEnabled: !0,
						children: [/* @__PURE__ */ E("p", {
							className: "text-base text-textSecondary",
							children: a("create.hints.partnerNodes")
						}), /* @__PURE__ */ D("div", {
							className: "grid gap-4 sm:grid-cols-2",
							children: [/* @__PURE__ */ E(h.Field, { name: "partnerNodeQm" }), /* @__PURE__ */ E(h.Field, { name: "partnerNodeTq" })]
						})]
					}),
					/* @__PURE__ */ E(z, {
						stepKey: "balanceCheck",
						position: x.balanceCheck,
						isEnabled: v,
						toggle: /* @__PURE__ */ E(h.Field, { name: "balanceCheckEnabled" }),
						children: /* @__PURE__ */ E(h.Field, { name: "minBalanceUsd" })
					}),
					/* @__PURE__ */ D(z, {
						stepKey: "activityGate",
						position: x.activityGate,
						isEnabled: y,
						toggle: /* @__PURE__ */ E(h.Field, { name: "activityGateEnabled" }),
						children: [/* @__PURE__ */ D("div", {
							className: "grid gap-4 sm:grid-cols-2",
							children: [
								/* @__PURE__ */ E(h.Field, { name: "activityMetric" }),
								b !== "trade_recency" && /* @__PURE__ */ E(h.Field, { name: "activityThreshold" }),
								/* @__PURE__ */ E(h.Field, { name: "activityWindowDays" }),
								/* @__PURE__ */ E(h.Field, { name: "activityCooldownDays" })
							]
						}), /* @__PURE__ */ E(h.Field, { name: "activityInstruments" })]
					}),
					/* @__PURE__ */ E(z, {
						stepKey: "grantAccess",
						position: x.grantAccess,
						isEnabled: !0,
						children: /* @__PURE__ */ E(h.Field, { name: "inviteLinkTtlMinutes" })
					})
				]
			}),
			/* @__PURE__ */ E(h.ErrorSummary, {}),
			/* @__PURE__ */ E("div", { children: /* @__PURE__ */ E(h.SubmitButton, {}) })
		]
	})] });
}
//#endregion
//#region src/lib/pages/CreateEntryFlowPage.tsx
function J({ backHref: t, getFlowHref: n }) {
	let { t: r } = _(N), i = v(), a = e();
	return /* @__PURE__ */ D(m, { children: [/* @__PURE__ */ E(h, {
		trail: [{
			href: t,
			label: r("view.back")
		}],
		title: r("create.title")
	}), /* @__PURE__ */ E(q, {
		submitLabel: r("create.submit"),
		onSubmit: async (e) => {
			let t = await a.mutateAsync(e);
			p.success({ title: r("create.created", { name: t.name }) }), i(n(t.id));
		}
	})] });
}
//#endregion
//#region src/lib/pages/EditEntryFlowPage.tsx
function Y({ backHref: e, getFlowHref: t }) {
	let { t: r } = _(N), { id: i = "" } = y(), s = v(), c = n(i), l = a(), u = (O().data ?? []).filter((e) => e.entryFlowId === i);
	return /* @__PURE__ */ D(m, { children: [
		/* @__PURE__ */ E(h, {
			trail: [{
				href: e,
				label: r("view.back")
			}, {
				href: t(i),
				label: c.data?.name ?? "…"
			}],
			title: r("edit.title")
		}),
		c.isPending && /* @__PURE__ */ E("p", {
			className: "text-base text-textSecondary",
			children: r("view.loading")
		}),
		c.isError && /* @__PURE__ */ E(o, {
			variant: "danger",
			title: r("view.loadFailed"),
			description: k(c.error, r("view.loadFailedDetail")),
			actionLabel: r("view.retry"),
			onAction: () => void c.refetch()
		}),
		c.data && /* @__PURE__ */ E(q, {
			initial: c.data,
			submitLabel: r("edit.submit"),
			notice: /* @__PURE__ */ E(o, {
				variant: "info",
				title: u.length > 0 ? r("edit.notice.usedBy", { names: u.map((e) => e.name).join(", ") }) : r("edit.notice.unused"),
				description: r("edit.notice.effect")
			}),
			onSubmit: async (e) => {
				let n = await l.mutateAsync({
					id: i,
					flow: e
				});
				p.success({ title: r("edit.done", { name: n.name }) }), s(t(n.id));
			}
		})
	] });
}
//#endregion
//#region src/lib/components/DeleteEntryFlowDialog.tsx
function X({ flow: e, onClose: n, onDeleted: r }) {
	let { t: i } = _(N), a = t(), o = async () => {
		try {
			await a.mutateAsync(e.id), p.success({ title: i("delete.done", { name: e.name }) }), r();
		} catch (t) {
			p.danger({
				title: i("delete.failed", { name: e.name }),
				description: k(t, i("delete.failedFallback"))
			});
		}
	};
	return /* @__PURE__ */ E(j, {
		open: !0,
		onOpenChange: (e) => !e && n(),
		title: i("delete.title", { name: e.name }),
		description: i("delete.description"),
		confirmLabel: i("delete.confirm"),
		cancelLabel: i("delete.cancel"),
		onConfirm: () => void o()
	});
}
//#endregion
//#region src/lib/components/StepsSummary.tsx
function Z({ flow: e }) {
	let { t } = _(N), n = L((t) => I(e, t));
	return /* @__PURE__ */ E(l, {
		title: t("view.steps"),
		className: "max-w-3xl",
		children: /* @__PURE__ */ E("ol", {
			className: "flex flex-col text-base",
			children: F.map((r) => {
				let i = n[r];
				return /* @__PURE__ */ D("li", {
					className: "grid grid-cols-[1.5rem_minmax(0,1fr)] gap-x-3 gap-y-1 border-t border-borderSecondary py-3 sm:grid-cols-[1.5rem_12rem_minmax(0,1fr)]",
					children: [
						/* @__PURE__ */ E("span", {
							className: "text-textSecondary tabular-nums",
							children: i ?? "–"
						}),
						/* @__PURE__ */ E("span", {
							className: i === void 0 ? "text-textTertiary" : "text-textPrimary",
							children: t(`steps.${r}.title`)
						}),
						/* @__PURE__ */ E("span", {
							className: "col-start-2 min-w-0 break-words text-textPrimary sm:col-start-3",
							children: i === void 0 ? /* @__PURE__ */ E(s, {
								size: "sm",
								children: t("view.off")
							}) : $(e, r, t)
						})
					]
				}, r);
			})
		})
	});
}
function Q(e) {
	return /* @__PURE__ */ E("span", {
		className: "font-mono break-all",
		children: e
	});
}
function $(e, t, n) {
	let { steps: r } = e, i = (e) => n("units.minutes", { count: e }), a = (e) => n("units.days", { count: e });
	switch (t) {
		case "languageSelect": return e.languages.join(", ");
		case "accountCheck": return r.accountCheck.referralLink ? Q(r.accountCheck.referralLink) : n("summary.noReferral");
		case "emailVerify": {
			let e = r.emailVerify;
			return n("summary.emailVerify", {
				length: e.codeLength,
				ttl: i(e.codeTtlMinutes),
				emails: e.maxEmailAttempts,
				codes: e.maxCodeAttempts,
				cooldown: n("units.seconds", { count: e.resendCooldownSeconds })
			});
		}
		case "ibCheck": {
			let e = Object.entries(r.ibCheck.partnerNodes);
			return e.length > 0 ? /* @__PURE__ */ E("span", {
				className: "flex flex-col",
				children: e.map(([e, t]) => /* @__PURE__ */ D("span", { children: [
					e.toUpperCase(),
					" ",
					Q(t)
				] }, e))
			}) : n("view.none");
		}
		case "balanceCheck": return r.balanceCheck ? n("summary.balanceCheck", {
			min: r.balanceCheck.minBalanceUsd,
			currency: "USD"
		}) : null;
		case "activityGate": {
			let e = r.activityGate;
			return e ? `${n(`summary.activity.${e.metric}`, {
				threshold: e.threshold,
				window: a(e.windowDays)
			})}${e.instruments?.length ? n("summary.activity.instruments", { instruments: e.instruments.join(", ") }) : ""}${e.cooldownDays ? n("summary.activity.cooldown", { cooldown: a(e.cooldownDays) }) : ""}` : null;
		}
		case "grantAccess": return n("summary.grantAccess", { ttl: i(r.grantAccess.inviteLinkTtlMinutes) });
		default: throw Error(`Unsupported step ${JSON.stringify(t)}`);
	}
}
//#endregion
//#region src/lib/pages/EntryFlowPage.tsx
function ee({ backHref: e, getEditHref: t }) {
	let { t: r } = _(N), { id: i = "" } = y(), a = n(i), s = v(), [l, u] = A(!1);
	return /* @__PURE__ */ D(m, { children: [
		/* @__PURE__ */ E(h, {
			trail: [{
				href: e,
				label: r("view.back")
			}],
			title: a.data?.name ?? "…",
			actions: a.data && /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ E(c, {
				variant: "secondary",
				iconStart: "pencil",
				onPress: () => void s(t(i)),
				children: r("edit.open")
			}), /* @__PURE__ */ E(c, {
				variant: "destructive",
				iconStart: "trash-2",
				onPress: () => u(!0),
				children: r("delete.open")
			})] })
		}),
		a.isPending && /* @__PURE__ */ E("p", {
			className: "text-base text-textSecondary",
			children: r("view.loading")
		}),
		a.isError && /* @__PURE__ */ E(o, {
			variant: "danger",
			title: r("view.loadFailed"),
			description: k(a.error, r("view.loadFailedDetail")),
			actionLabel: r("view.retry"),
			onAction: () => void a.refetch()
		}),
		a.data && /* @__PURE__ */ E(te, { flow: a.data }),
		l && a.data && /* @__PURE__ */ E(X, {
			flow: a.data,
			onClose: () => u(!1),
			onDeleted: () => void s(e, { replace: !0 })
		})
	] });
}
function te({ flow: e }) {
	let { t } = _(N);
	return /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ E(l, {
		title: t("view.general"),
		className: "max-w-3xl",
		children: /* @__PURE__ */ E(g, { items: [
			{
				label: t("fields.languages"),
				value: e.languages.join(", ")
			},
			{
				label: t("fields.defaultLanguage"),
				value: e.defaultLanguage
			},
			{
				label: t("fields.maxStepRetries"),
				value: e.maxStepRetries
			}
		] })
	}), /* @__PURE__ */ E(Z, { flow: e })] });
}
//#endregion
//#region src/lib/pages/EntryFlowsPage.tsx
function ne({ createHref: e, getFlowHref: t }) {
	let { t: n } = _(N), i = b(), a = v(), o = () => void a(e), l = [
		{
			id: "name",
			label: n("columns.name"),
			isRowHeader: !0,
			isSortable: !0,
			width: 240,
			cell: (e) => e.name
		},
		{
			id: "languages",
			label: n("columns.languages"),
			width: 200,
			skeleton: "pill",
			cell: (e) => /* @__PURE__ */ E("div", {
				className: "flex flex-wrap gap-1",
				children: e.languages.map((e) => /* @__PURE__ */ E(s, {
					size: "sm",
					shape: "square",
					children: e
				}, e))
			})
		},
		{
			id: "steps",
			label: n("columns.steps"),
			cell: (e) => /* @__PURE__ */ E("span", {
				className: "text-textSecondary",
				children: F.filter((t) => I(e, t)).map((e) => n(`steps.${e}.title`)).join(" → ")
			})
		}
	], u = M({
		"aria-label": n("table.label"),
		columns: l,
		defaultSort: {
			by: "name",
			order: "asc"
		},
		getRowKey: (e) => e.id,
		getRowHref: (e) => t(e.id),
		searchParams: i,
		filters: { query: {
			type: "search",
			label: n("filters.search"),
			defaultValue: ""
		} }
	}), d = r(u.requestParams, u.filters);
	return /* @__PURE__ */ D(m, { children: [/* @__PURE__ */ E(h, { title: n("title") }), /* @__PURE__ */ D(u.Frame, { children: [/* @__PURE__ */ E(u.Toolbar, { children: /* @__PURE__ */ E(c, {
		iconStart: "plus",
		onPress: o,
		children: n("create.open")
	}) }), /* @__PURE__ */ E(u.Table, {
		query: d,
		emptyState: {
			icon: "workflow",
			title: n("empty.title"),
			actionLabel: n("create.open"),
			onAction: o
		}
	})] })] });
}
//#endregion
export { J as CreateEntryFlowPage, Y as EditEntryFlowPage, ee as EntryFlowPage, ne as EntryFlowsPage, N as FEATURE_SPG_ENTRY_FLOWS_NAMESPACE };
